<template>
  <div>
    <vue-headful :title="pageTitle"/>
    <h2 class="text-xs-center">{{title}}</h2>
    <div class="text-xs-center pagination">
      <v-pagination :length="questions.length" v-model="currentQuestion" @input="showQuestion"/>
    </div>
    <form @submit.prevent="endThematicStage">
      <v-card class="question">
        <v-card-text v-show="question.display" v-for="(question, index) in questions" :key="index">
          <h3>{{(index + 1) + '. ' + question.text}}</h3>
          <v-radio-group @change="saveAnswer(question.id)" v-model="answersForSend[question.id].answerId">
            <div v-for="(answer, aindex) in question.answers" :key="aindex"
                 :class="'answer '+radioAnswer(question.id, answer.id)">
              <v-radio :value="answer.id" class="answer__radio"/>
              <div class="answer__text" v-html="answer.text" @click="chooseAnswer(question.id, answer.id)"></div>
            </div>
          </v-radio-group>
        </v-card-text>
        <div class="buttons">
          <v-btn color="success" :disabled="currentQuestion===questions.length" @click="toNext">Далее</v-btn>
          <v-btn flat :disabled="currentQuestion===1" @click="toPrev">Назад</v-btn>
        </div>
      </v-card>
      <v-btn type="submit" class="mt-3 mx-auto d-block" color="success" :disabled="canEnd">
        Закончить тематическую часть и перейти к следующему этапу
      </v-btn>
    </form>
  </div>
</template>

<script>
import AttestationService from '@/services/AttestationService'
import SettingsService from '@/services/SettingsService'

export default {
  data: () => ({
    title: 'Тематические вопросы',
    questions: [],
    answersForSend: {},
    currentQuestion: 1,
    answeredPaginationItems: [],
    prevQuestion: 1,
    attestationService: undefined
  }),
  computed: {
    pageTitle () {
      return SettingsService.pageTitle(this.title)
    },
    canEnd () {
      for (let item in this.answersForSend) {
        if (this.answersForSend[item].answerId === undefined) {
          return true
        }
      }
      return false
    }
  },
  methods: {
    initPagination () {
      this.$el.querySelectorAll('.pagination li button').forEach(btn => {
        if (this.answeredPaginationItems.indexOf(btn.textContent) > -1) {
          btn.classList.add('answered')
        } else {
          btn.classList.remove('answered')
        }
      })
    },
    showQuestion () {
      setTimeout(function (context) {
        context.initPagination()
      }, 100, this)
      this.questions[this.prevQuestion - 1].display = false
      this.questions[this.currentQuestion - 1].display = true
      this.prevQuestion = this.currentQuestion
    },
    toPrev () {
      this.$scrollTo('body', 700)
      this.currentQuestion--
      this.showQuestion()
    },
    toNext () {
      this.$scrollTo('body', 700)
      this.currentQuestion++
      this.showQuestion()
    },
    endThematicStage () {
      this.attestationService.endThematicStage((data) => {
        if (data.status) {
          this.$router.push('/attestation/practice')
        }
      })
    },
    radioAnswer (questionId, answerId) {
      if (sessionStorage.getItem('isTraining').toLowerCase() === 'true' && this.answersForSend[questionId].answerId !== undefined) {
        for (let qIndex in this.questions) {
          let question = this.questions[qIndex]
          if (question.id !== questionId) {
            continue
          }
          let answers = question.answers
          for (let aIndex in answers) {
            let answer = answers[aIndex]
            if (answer.id === answerId && answer.cost === 10) {
              return 'green-back-answer'
            }
            if (answer.id !== this.answersForSend[questionId].answerId) {
              continue
            }
            if (answer.id === answerId) {
              if (answer.cost === 0) {
                return 'red-back-answer'
              }
              if (answer.cost === 5) {
                return 'yellow-back-answer'
              }
            }
          }
        }
      }
      return ''
    },
    saveAnswer (questionId) {
      this.answeredPaginationItems.push(this.currentQuestion.toString())
      let answerId = this.answersForSend[questionId].answerId
      this.attestationService.saveThematicAnswer(questionId, answerId, (data) => {
      })
    },
    chooseAnswer (qId, aId) {
      this.answersForSend[qId].answerId = aId
      this.saveAnswer(qId)
    }
  },
  created () {
    this.attestationService = new AttestationService(this.$store)
    this.attestationService.getStudentAttestationInfo((data) => {
      if (data.info.thematicStageEnded) {
        this.$router.push('/attestation/practice')
      } else if (!data.info.testStageEnded) {
        this.$router.push('/attestation/test')
      } else {
        this.attestationService.getThematicQuestions((list) => {
          let questions = []
          let answers = {}
          let index = 1
          list.forEach(activeQuestion => {
            activeQuestion.question.display = false
            questions.push(activeQuestion.question)
            if (activeQuestion.answer) {
              answers[activeQuestion.question.id] = {answerId: activeQuestion.answer}
              this.answeredPaginationItems.push(index.toString())
            } else {
              answers[activeQuestion.question.id] = {answerId: undefined}
            }
            index++
          })
          this.questions = questions
          this.answersForSend = answers
          this.showQuestion()
        })
      }
    })
  }
}
</script>

<style lang="scss" scoped>

.question {
  margin-top: 20px;

  /deep/ label {
    color: rgba(0, 0, 0, 0.8) !important;
  }

  .buttons {
    margin-top: -20px;
    padding: 0 10px 10px;
    display: flex;
    justify-content: space-between;
  }
}

.green-back-answer {
  border-radius: 8px;
  background: rgba(0, 255, 0, 0.05);
}

.yellow-back-answer {
  border-radius: 8px;
  background: rgba(255, 255, 0, 0.25);
}

.red-back-answer {
  border-radius: 8px;
  background: rgba(255, 0, 0, 0.05);
}

.answer {
  display: flex;
  border-top: 2px solid #dedede;
  padding-top: 20px;

}

.answer__radio {
  margin-right: 15px;
}

.answer__text {
  cursor: pointer;
  width: 100%;
}

.pagination {
  /deep/ .answered {
    background: #757575  !important;
    color: #fff  !important;
  }

  /deep/ .v-pagination__item {
    transition-duration: 0.0s;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/student/attestation/Thematic.vue